import { layout } from '../../App.routing'

export const politicsSegment = layout.nestedComposition({
    type: 'janus',
    props: {
        layoutRatio: '1:3',
        stretchColumns: true,
        verticalSpacing: 'xl',
    },
    contentAreas: {
        left: [
            layout.component({
                type: 'section-header',
                props: {
                    heading: 'Promotional',
                    hasMargin: true,
                    invisibleHeaderBreakpoint: 'md',
                },
            }),

            layout.component({
                type: 'curated-promotional-card',
                props: {
                    fixedRatio: '4:3',
                    hasBackground: true,
                    hasPadding: true,
                    mediaMode: 'edgeToEdge',
                    fontScale: 0.88,
                    showCTA: true,
                    cardOrientation: {
                        defaultLayout: 'landscape',
                        alternativeLayoutOptions: {
                            breakpoint: 'md',
                            layout: 'portrait',
                        },
                    },
                    verticalSpacing: 'md',
                    dataDefinitionArgs: {
                        type: 'active-promotion',
                        promotionSlotId: 'homepage-position-2',
                    },
                },
            }),
        ],
        right: [
            layout.component({
                type: 'lima',
                props: {
                    fixedRatios: ['16:9'],
                    intermediateColumns: 3,
                    finalColumns: 3,
                    teaserMode: 'hidden',
                    hideByline: false,
                    hasBackground: true,
                    cardOrientation: { type: 'Landscape-Portrait' },

                    cardLayout: [
                        ['teaserWithBackground'],
                        [
                            'teaser-xsVisible-mdHidden-Image',
                            'teaser-xsVisible-smHidden-noImage',
                        ],
                        [
                            'teaser-xsVisible-mdHidden-Image',
                            'teaser-xsVisible-smHidden-noImage',
                        ],
                    ],
                    sectionHeader: {
                        heading: 'Politics',
                        headingUrl: '/politics',
                        section: 'politics',
                    },
                    dataDefinitionArgs: {
                        type: 'curation',
                        name: 'politics',
                        offset: 0,
                        pageSize: 5,
                    },
                },
            }),
        ],
    },
})
